import React from 'react';
import { motion } from 'framer-motion';
interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
  label: string;
}
export function StepIndicator({
  currentStep,
  totalSteps,
  label
}: StepIndicatorProps) {
  const displayStep = currentStep - 1;
  const displayTotal = 8;
  if (currentStep === 1 || currentStep >= 10) return null;
  return <div className="w-full mb-6" data-id="element-1115">
      <div className="flex gap-1 mb-3" data-id="element-1116">
        {Array.from({
        length: displayTotal
      }).map((_, i) => {
        const stepNumber = i + 1;
        let bgColor = 'bg-slate-800';
        if (stepNumber === displayStep) bgColor = 'bg-yellow-500';else if (stepNumber < displayStep) bgColor = 'bg-green-500';
        return <motion.div key={i} className={`h-1.5 flex-1 rounded-full ${bgColor}`} layout transition={{
          duration: 0.3
        }} data-id="element-1117" />;
      })}
      </div>
      <div className="flex justify-between items-center text-xs font-medium" data-id="element-1118">
        <span className="text-yellow-500 uppercase tracking-wider" data-id="element-1119">
          Step {displayStep} of {displayTotal}
        </span>
        <span className="text-slate-400" data-id="element-1120">{label}</span>
      </div>
    </div>;
}